import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ShoppingCart, Star } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { country } = useParams();
  const { addToCart } = useCart();

  const price = product.sale_price || product.regular_price;
  const hasDiscount = product.sale_price && product.sale_price < product.regular_price;
  const discountPercent = hasDiscount 
    ? Math.round(((product.regular_price - product.sale_price) / product.regular_price) * 100)
    : 0;

  const handleClick = () => {
    navigate(`/${country}/products/${product.id}`);
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product, 1);
  };

  return (
    <div
      onClick={handleClick}
      className="min-w-[250px] bg-white rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:transform hover:scale-105 hover:shadow-xl"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative h-64 overflow-hidden bg-gray-100">
        <img
          src={product.images?.[0]?.url || 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&q=80'}
          alt={product.name}
          className="w-full h-full object-cover"
        />
        {hasDiscount && (
          <div className="absolute top-2 right-2 bg-aug-green-success text-white px-2 py-1 rounded-full text-xs font-bold">
            -{discountPercent}%
          </div>
        )}
        {!product.in_stock && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <span className="text-white font-bold text-lg">Esgotado</span>
          </div>
        )}
      </div>

      <div className="p-4">
        <p className="text-xs text-aug-blue font-medium mb-1">
          {product.category_name}
        </p>

        <h3 className="text-base font-semibold text-aug-gray-dark mb-2 line-clamp-2">
          {product.name}
        </h3>

        {product.reviews_count > 0 && (
          <div className="flex items-center gap-1 mb-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-3 h-3 ${
                    i < Math.floor(product.average_rating)
                      ? 'fill-aug-warning text-aug-warning'
                      : 'text-gray-300'
                  }`}
                />
              ))}
            </div>
            <span className="text-xs text-aug-gray-medium">
              ({product.reviews_count})
            </span>
          </div>
        )}

        <div className="flex items-baseline gap-2 mb-3">
          <span className="text-2xl font-bold text-aug-green">
            R$ {price.toFixed(2)}
          </span>
          {hasDiscount && (
            <span className="text-sm text-aug-gray-medium line-through">
              R$ {product.regular_price.toFixed(2)}
            </span>
          )}
        </div>

        <button
          onClick={handleAddToCart}
          className="w-full flex items-center justify-center gap-2 bg-aug-blue hover:bg-aug-blue-dark text-white py-2 rounded-lg transition-colors duration-300"
          disabled={!product.in_stock}
        >
          <ShoppingCart className="w-4 h-4" />
          <span className="text-sm font-medium">
            {product.in_stock ? 'Adicionar' : 'Esgotado'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;